import { useDispatch, useSelector } from 'react-redux';
import { use100vh } from 'react-div-100vh';
import { useEffect } from 'react';

import { setSplashLoaded } from '../../../store/slices/generalSlice';
import { RootState } from '../../../store/rootReducer';
import storageService from '../../../services/storage.service';
import { INSURANCE_COMPANIES } from '../../../constants';
import { images } from '../../../assets/images/images';
import { SplashesStyle } from './splashes-style';

const defaultLogo = (
  <div className="welcome welcome--active">
    <img src={images.logoWhite} alt="Asitur logo" />
  </div>
);

const Splashes = () => {
  const provider = useSelector((state: RootState) => state.general.provider);
  const dispatch = useDispatch();
  const height = use100vh();

  useEffect(() => {
    const splashLoadingTimeoutId = setTimeout(() => {
      storageService.setLocalItem('splashLoaded', true);
      void dispatch(setSplashLoaded({ loaded: true }));
    }, 4000);

    return () => {
      clearTimeout(splashLoadingTimeoutId);
    };
  }, [dispatch]);

  const logo =
    provider && INSURANCE_COMPANIES?.[provider] ? (
      <img src={INSURANCE_COMPANIES?.[provider]?.img} alt={INSURANCE_COMPANIES?.[provider]?.alt} />
    ) : (
      defaultLogo
    );

  return <SplashesStyle style={{ height: height || window?.innerHeight }}>{logo}</SplashesStyle>;
};

export default Splashes;
